import { useEffect, useRef, useState } from "react";
import Loader from "../../common/Loader";
import {
  dieMasterAPI,
  DieUnloadReasonAPI,
  inProduction,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Button from "../../common/Button";
import InputField from "../../common/InputField";
import { IoIosSave } from "react-icons/io";
import { RiHistoryLine, RiRefreshLine } from "react-icons/ri";
import { Card } from "../../common/Shared";
import {
  ChevronDown,
  ChevronUp,
  Info,
  LayoutGrid,
  Package,
  RefreshCw,
} from "lucide-react";
import { BsFillSkipStartFill } from "react-icons/bs";
import { STATUS_COLORS } from "../../utlis/constant";
import { AnimatePresence, motion } from "framer-motion";
import { MdClose } from "react-icons/md";
import { TiRefreshOutline } from "react-icons/ti";

const ProductionCard = ({
  row,
  index,
  isModal = false,
  handleSave,
  handleActionChange,
  handleProdStart,
  handleRowChange,
  handleSaveBilletChange,
  calcFinal,
  safeDiv,
  isCastingData,
  dieUnloadReason,
  inProductionData,
  handleDieUnload,
}) => (
  <div
    key={index}
    className="bg-white shadow-sm border border-slate-200 rounded-2xl overflow-hidden hover:shadow-md transition-shadow"
  >
    <div className="bg-slate-50 px-5 py-4 border-b border-slate-200 flex flex-wrap justify-between items-center gap-4">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
            Order:
          </span>
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white border font-bold text-sm text-primary shadow-sm">
            {row.order_No}
          </span>
          {row.order_Status && (
            <span className="bg-green-50 text-green-700 border border-green-100 px-3 py-1 rounded-md text-xs font-bold">
              {row.order_Status}
            </span>
          )}
        </div>

        <div className="flex flex-wrap gap-2">
          <span className="bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-md text-xs font-bold">
            Batch: {row.batch_Id}
          </span>
          <span className="bg-purple-50 text-purple-700 border border-purple-100 px-3 py-1 rounded-md text-xs font-bold">
            Profile: {row.profile_Name}
          </span>
          <span className="bg-slate-100 text-slate-700 border border-slate-200 px-3 py-1 rounded-md text-xs font-bold">
            Die: {row.dieNumber}
          </span>
          <span className="bg-orange-50 text-orange-700 border border-orange-100 px-3 py-1 rounded-md text-xs font-bold">
            Ord Pcs: {row.qty_Pcs}
          </span>
          <span className="bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1 rounded-md text-xs font-bold">
            Ord Wt: {row.qty_Weight}
          </span>
          <span className="bg-yellow-50 text-yellow-700 border border-yellow-100 px-3 py-1 rounded-md text-xs font-bold">
            Cut Length: {row.cut_Length}
          </span>
          <span className="bg-pink-50 text-pink-700 border border-pink-100 px-3 py-1 rounded-md text-xs font-bold">
            Current Wt: {row.current_Die_Weight}
          </span>
        </div>
      </div>

      <div className="flex gap-2">
        {isModal || row.order_Status === "RUNNING" || row.order_Status === "COMPLETED" ? (
          <>
            {!isModal && (
              <select
                className="bg-white text-slate-700 border border-slate-200 px-2 py-1 rounded-md text-xs font-bold outline-none focus:border-blue-300 shadow-sm cursor-pointer"
                onChange={(e) => handleActionChange(index, e.target.value)}
                value={row.selectedAction || ""}
              >
                <option value="">Select Action</option>
                <option value="billet_change" disabled={row.order_Status === "COMPLETED"} className={`${row.order_Status === "COMPLETED" ? "text-slate-400" : ""}`}>Billet Change</option>
                <option value="die_unload" disabled={row.order_Status === "COMPLETED"} className={`${row.order_Status === "COMPLETED" ? "text-slate-400" : ""}`}>Die Unload</option>
                <option value="mark_done">Mark Done</option>
              </select>
            )}

            <button
              onClick={() => {
                if (isModal) {
                  return handleSaveBilletChange();
                }

                const act = inProductionData[index]?.selectedAction;
                const reason = inProductionData[index]?.die_Unload_Reason_Id;

                if (act === "die_unload") {
                  if (!reason) return notify("Unload reason required!", "error");

                  return handleDieUnload(inProductionData[index], index);
                } else {
                  handleSave(row, index);
                }
              }}
              className="p-2.5 text-green-600 hover:bg-green-50 rounded-xl border border-transparent hover:border-green-200 transition-all font-bold text-xs flex items-center gap-2"
              title="Save"
            >
              <IoIosSave size={22} /> {isModal ? "Save Billet Change" : ""}
            </button>
          </>
        ) : (
          !isModal && (
            <button
              className="p-2.5 flex text-blue-600 bg-blue-50 rounded-xl border border-blue-400 hover:border-green-200 transition-all font-bold text-xs items-center gap-2"
              title="Start Production"
              onClick={() => handleProdStart(row, index)}
            >
              <BsFillSkipStartFill size={22} /> Prod. Start
            </button>
          )
        )}
      </div>
    </div>
    <div className="p-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-6">
        <InputField
          label="Casting No"
          type="select"
          options={isCastingData}
          value={row.casting_No}
          onChange={(val) => handleRowChange(index, "casting_No", val)}
          required
        />

        <InputField
          label="Die In"
          type="time"
          value={row.die_In}
          onChange={(e) => handleRowChange(index, "die_In", e)}
        />

        <InputField
          label="Die Out"
          type="time"
          value={row.die_Out}
          onChange={(e) => handleRowChange(index, "die_Out", e)}
        />

        <InputField
          label="Pcs Needed"
          value={row.pcs_Needed}
          onChange={(e) => handleRowChange(index, "pcs_Needed", e)}
        />

        <div className="flex flex-col gap-1">
          <InputField
            label="Billet Size"
            value={row.billet_Size}
            onChange={(e) => handleRowChange(index, "billet_Size", e)}
            required
          />
          {(() => {
            const v = calcFinal(row);
            return (
              v !== null && (
                <div className="flex items-center gap-1.5 px-2 py-1 bg-indigo-50 text-indigo-700 rounded-md border border-indigo-100 w-fit">
                  <span className="text-[10px] uppercase font-bold">Size:</span>
                  <span className="text-xs font-black">{v.toFixed(2)}</span>
                </div>
              )
            );
          })()}
        </div>

        <div className="flex flex-col gap-1">
          <InputField
            label="No Of Billets"
            value={row.no_Of_Billet}
            onChange={(e) => handleRowChange(index, "no_Of_Billet", e)}
            required
          />
          {(() => {
            const ratio = safeDiv(row.qty_Pcs, row.pcs_Needed);
            return (
              ratio !== null && (
                <div className="flex items-center gap-1.5 px-2 py-1 bg-amber-50 text-amber-700 rounded-md border border-amber-100 w-fit">
                  <span className="text-[10px] uppercase font-bold">Pcs:</span>
                  <span className="text-xs font-black">{ratio.toFixed(2)}</span>
                </div>
              )
            );
          })()}
        </div>

        <InputField
          label="Input Wt"
          value={row.input_Weight}
          unit="Kg"
          disabled
        />

        <InputField
          label="No Of Pcs"
          value={row.no_Of_Pcs}
          onChange={(e) => handleRowChange(index, "no_Of_Pcs", e)}
        />

        <InputField
          label="Out Wt"
          value={row.output_Weight}
          onChange={(e) => handleRowChange(index, "output_Weight", e)}
        />

        <InputField label="Recov (%)" value={row.recovry} disabled />

        <InputField
          label="But End Rej."
          value={row.but_End_Rejection_Mm}
          onChange={(e) => handleRowChange(index, "but_End_Rejection_Mm", e)}
          unit="mm"
        />
        <InputField
          label="Stretching Rej."
          value={row.stertching_Rejection_Ft}
          onChange={(e) => handleRowChange(index, "stertching_Rejection_Ft", e)}
          unit="Ft"
        />
        <InputField
          label="Ext Spd"
          value={row.ext_Speed}
          onChange={(e) => handleRowChange(index, "ext_Speed", e)}
        />

        <InputField
          label="Billet Temp"
          value={row.billet_Temp}
          onChange={(e) => handleRowChange(index, "billet_Temp", e)}
        />

        <InputField
          type="textarea"
          label="Remarks"
          value={row.remark}
          onChange={(e) => handleRowChange(index, "remark", e)}
        />

        <InputField
          type="select"
          label="Unload Reason"
          placeholder="Select reason"
          required
          options={dieUnloadReason}
          value={row.die_Unload_Reason_Id || ""}
          onChange={(val) => {
            handleRowChange(index, "die_Unload_Reason_Id", val);
          }}
        />
      </div>
    </div>
  </div >
);

const InProduction = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [inProductionData, setInProductionData] = useState([]);
  const [isCastingData, setIsCastingData] = useState([]);
  const [isMarkDoneData, setIsMarkDoneData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 50;
  const [activeTab, setActiveTab] = useState("in-ProductionData");
  const [selectedDies, setSelectedDies] = useState([]);
  const [dieList, setDieList] = useState([]);
  const [dieUnloadReason, setDieUnloadReason] = useState([]);
  const [isTableExpanded, setIsTableExpanded] = useState(true);
  const tableScrollRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);
  const [isBilletModelOpen, setIsBilletModelOpen] = useState(false);
  const [billetModalRow, setBilletModalRow] = useState(null);

  const toggleDieSelection = (id) => {
    setSelectedDies((prev) => {
      const isSelected = prev.includes(id);
      if (isSelected) {
        const updatedSelection = prev.filter((x) => x !== id);
        setInProductionData((prevData) =>
          prevData.filter((row) => row.die_Id !== id),
        );
        return updatedSelection;
      } else {
        return [...prev, id];
      }
    });
  };

  const fetchMarkDoneData = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await inProduction.getAllInMarkDone(currentPage, pageSize);

      const list = res?.data || [];

      if (currentPage === 1) {
        setIsMarkDoneData(list);
      } else {
        setIsMarkDoneData((prev) => [...prev, ...list]);
      }

      if (list.length < pageSize) {
        setHasMore(false);
      }
    } catch (error) {
      notify("Error fetching Casting data", "error");
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [castingNoRes, ReasonRes] = await Promise.all([
        inProduction.getAllCastingNo(),
        DieUnloadReasonAPI.getAll(),
      ]);
      setIsCastingData(
        castingNoRes.map((cas) => ({
          value: cas.casting_No,
          label: cas.casting_No,
        })),
      );
      setDieUnloadReason(
        ReasonRes.data.map((cas) => ({
          value: cas.id,
          label: cas.reason,
        })),
      );
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const fetchInProductionData = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const res = await inProduction.getAllInProduction(
        selectedDies,
        currentPage,
        pageSize,
      );

      const list = res?.data || [];

      if (currentPage === 1) {
        setInProductionData(list);
      } else {
        setInProductionData((prev) => [...prev, ...list]);
      }

      if (list.length < pageSize) {
        setHasMore(false);
      }
    } catch (err) {
      notify("Error fetching Order Plan data", "error");
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  const fetchDies = async () => {
    try {
      const res = await dieMasterAPI.getAllDieForBatches();
      setDieList(
        res.map((d) => ({
          die_Id: d.die_Id,
          dieNumber: d.dieNumber,
          die_Status_Id: d.die_Status_Id,
          die_Status: d.die_Status,
          currentWeight: d.currentWeight,
          cutLength: d.cut_Length,
          orderPcs: d.order_PCS,
          orderPcsWeight: d.order_Weight,
          soNo: d.order_No,
          batchId: d.batch_Id,
        })),
      );
    } catch (err) {
      console.log("Error loading die list", err);
    }
  };

  const handleRefresh = () => {
    if (selectedDies.length === 0) {
      setInProductionData([]);
      return;
    }
    setCurrentPage(1);
    fetchInProductionData();
    setIsTableExpanded(false);
  };

  useEffect(() => {
    fetchData();
    fetchDies();
  }, []);

  useEffect(() => {
    if (selectedDies.length > 0) {
      fetchInProductionData();
    }
  }, [currentPage]);

  useEffect(() => {
    if (activeTab === "finish") {
      fetchMarkDoneData(1);
    }
  }, [activeTab]);

  const calculateRowValues = (row) => {
    const billetSize = parseFloat(row.billet_Size) || 0;
    const noOfBillet = parseFloat(row.no_Of_Billet) || 0;
    const outWt = parseFloat(row.output_Weight) || 0;
    const inputWt = 0.0386 * billetSize * noOfBillet;

    if (!isNaN(inputWt)) {
      row.input_Weight = parseFloat(inputWt.toFixed(2));
    }

    if (row.input_Weight > 0 && outWt > 0) {
      const recovery = (outWt / row.input_Weight) * 100;
      row.recovry = parseFloat(recovery.toFixed(2));
    } else {
      row.recovry = 0;
    }
    return row;
  };

  const handleRowChange = (index, field, value) => {
    const updated = [...inProductionData];
    let row = updated[index];

    row[field] = value;
    if (row.isCloned) {
      row.isCloned = false;
    }

    row = calculateRowValues(row);
    setInProductionData(updated);
  };

  const handleModalRowChange = (field, value) => {
    setBilletModalRow((prev) => {
      if (!prev) return prev;
      let updatedNew = { ...prev.new, [field]: value };
      updatedNew = calculateRowValues(updatedNew);
      return { ...prev, new: updatedNew };
    });
  };


  const handleSave = async (row, index, opts = {}) => {
    const { skipRefresh = false } = opts;
    if (!row.casting_No) return notify("Casting No required!", "error");
    if (!row.billet_Size) return notify("Billet Size required!", "error");
    if (!row.no_Of_Billet) return notify("No of billets required!", "error");
    const payload = {
      seq_No: row.seq_No,
      die_Id: row.die_Id,
      order_No: row.order_No,
      order_Qty_Pcs: parseInt(row.qty_Pcs) || 0,
      order_Qty_Weight: parseFloat(row.qty_Weight) || 0,
      casting_No: row.casting_No?.value || row.casting_No,
      Cut_Length: parseFloat(row.cut_Length) || 0,
      pcs_Needed: parseFloat(row.pcs_Needed) || 0,
      stertching_Rejection_Ft: parseFloat(row.stertching_Rejection_Ft) || 0,
      but_End_Rejection_Mm: parseFloat(row.but_End_Rejection_Mm) || 0,
      die_In_Time: row.die_In,
      die_Out_Time: row.die_Out,
      act_Output_WT: parseFloat(row.output_Weight) || 0,
      act_Input_WT: parseFloat(row.input_Weight) || 0,
      rec_Billet_Length: parseFloat(row.billet_Size) || 0,
      rec_Billet_PCS: parseInt(row.no_Of_Billet) || 0,
      act_production_Qty: parseInt(row.no_Of_Pcs) || 0,
      act_Yield_Per: parseFloat(row.recovry) || 0,
      extrusion_Speed: parseFloat(row.ext_Speed) || 0,
      billetTemp: parseFloat(row.billet_Temp) || 0,
      extrusion_Pressure: parseFloat(row.extrusion_Pressure) || 0,
      remark: row.remark || "",
      created_By: userId,
    };

    try {
      await inProduction.saveOrUpdate(payload);
      if (!skipRefresh) {
        fetchInProductionData();
      }
      notify(`Row ${index + 1} saved successfully!`, "success");
    } catch (error) {
      notify(`Failed to save Row ${index + 1}`, "error");
    }
  };

  const buildBilletPayload = (row) => {
    const payload = {
      currentSeqNo: row.seq_No || 0,
      castingNo: row.casting_No?.value || row.casting_No,
      dieInTime: row.die_In,
      dieOutTime: row.die_Out,
      actOutputWt: parseFloat(row.output_Weight) || 0,
      actInputWt: parseFloat(row.input_Weight) || 0,
      recBilletLength: parseFloat(row.billet_Size) || 0,
      recBilletPcs: parseInt(row.no_Of_Billet) || 0,
      actButtEnd: parseFloat(row.but_End_Rejection_Mm) || 0,
      actProductionQty: parseInt(row.no_Of_Pcs) || 0,
      actYieldPer: parseFloat(row.recovry) || 0,
      extrusionSpeed: parseFloat(row.ext_Speed) || 0,
      billetTemp: parseFloat(row.billet_Temp) || 0,
      extrusionPressure: parseFloat(row.extrusion_Pressure) || 0,
      remark: row.remark || "",
      butEndRejectionMm: parseFloat(row.but_End_Rejection_Mm) || 0,
      stretchingRejectionFt: parseFloat(row.stertching_Rejection_Ft) || 0,
      pcsNeeded: parseFloat(row.pcs_Needed) || 0,
      userId: userId,
    };

    return payload;
  };
  const handleSaveBilletChange = async () => {
    if (!billetModalRow?.old || !billetModalRow?.new) return;

    const oldRow = { ...billetModalRow.old };
    const newRow = { ...billetModalRow.new };

    if (!oldRow.casting_No) return notify("Old Row Casting No required!", "error");
    if (!oldRow.billet_Size)
      return notify("Old Row Billet Size required!", "error");
    if (!oldRow.no_Of_Billet)
      return notify("Old Row No of billets required!", "error");

    if (!newRow.casting_No) return notify("Casting No required!", "error");
    if (!newRow.billet_Size) return notify("Billet Size required!", "error");
    if (!newRow.no_Of_Billet) return notify("No of billets required!", "error");

    // Set Die Out for old row
    oldRow.die_Out = billetModalRow.currentTime;

    const oldPayload = buildBilletPayload(oldRow);

    try {
      // 1. Save Billet Change for Old Row
      await inProduction.saveBilletChange(oldPayload);

      // 2. Save New Production Entry
      await handleSave(newRow, billetModalRow.index, { skipRefresh: true });

      notify("Billet changed successfully!", "success");
      closeBilletModal();
      fetchInProductionData();
      // If there's an aging refresh function, call it here
    } catch (err) {
      notify("Billet change failed!", "error");
    }
  };


  const handleMarkDone = async (index) => {
    const row = inProductionData[index];
    const payload = {
      seq_No: row.seq_No,
      order_No: row.order_No,
      die_Id: row.die_Id,
      casting_No: row.casting_No?.value || row.casting_No,
      Cut_Length: parseFloat(row.cut_Length) || 0,
      pcs_Needed: parseFloat(row.pcs_Needed) || 0,
      stertching_Rejection_Ft: parseFloat(row.stertching_Rejection_Ft) || 0,
      but_End_Rejection_Mm: parseFloat(row.but_End_Rejection_Mm) || 0,
      die_In_Time: row.die_In,
      die_Out_Time: row.die_Out,
      act_Output_WT: parseFloat(row.output_Weight) || 0,
      act_Input_WT: parseFloat(row.input_Weight) || 0,
      rec_Billet_Length: parseFloat(row.billet_Size) || 0,
      rec_Billet_PCS: parseInt(row.no_Of_Billet) || 0,
      act_production_Qty: parseInt(row.no_Of_Pcs) || 0,
      act_Yield_Per: parseFloat(row.recovry) || 0,
      extrusion_Speed: parseFloat(row.ext_Speed) || 0,
      billetTemp: parseFloat(row.billet_Temp) || 0,
      extrusion_Pressure: parseFloat(row.extrusion_Pressure) || 0,
      remark: row.remark || "",
      created_By: userId,
    };

    try {
      await inProduction.saveOrUpdate(payload);
      notify(
        `Row ${index + 1} saved successfully before marking done!`,
        "success",
      );
      await inProduction.MarkProductionDone({
        batch_Id: row.batch_Id,
        seq_No: row.seq_No || 0,
        created_By: userId,
      });

      notify(`Row ${index + 1} marked as done!`, "success");
      fetchInProductionData(selectedDies?.value);
    } catch (error) {
      notify(`Failed to save or mark row ${index + 1} as done`, "error");
      console.error(error);
    }
  };

  const outputWtTotal = isMarkDoneData.reduce(
    (sum, row) => sum + (parseFloat(row.output_Weight) || 0),
    0,
  );

  const pcsTotal = isMarkDoneData.reduce(
    (sum, row) => sum + (parseFloat(row.no_Of_Pcs) || 0),
    0,
  );

  const n = (v) => {
    const x = parseFloat(v);
    return Number.isFinite(x) ? x : 0;
  };

  const safeDiv = (a, b) => {
    const A = n(a),
      B = n(b);
    return B > 0 ? A / B : null;
  };

  const calcFinal = (r) => {
    const currentDiePer12 = n(r.current_Die_Weight);
    const cutLenFt = n(r.cut_Length);
    const pcsNeeded = n(r.pcs_Needed);
    const butEndMm = n(r.but_End_Rejection_Mm);
    const stretchFt = n(r.stertching_Rejection_Ft);
    const cutLenMM = cutLenFt * 304.8;
    const secondCal = (currentDiePer12 / 3660) * cutLenMM;

    const suggBilletlength =
      secondCal * pcsNeeded +
      butEndMm * 0.0386 +
      (currentDiePer12 / 3660) * stretchFt * 304;

    const final = suggBilletlength / 0.0386;
    return Number.isFinite(final) ? final : null;
  };

  const columns = [
    { key: "seq_No", label: "Seq No" },
    {
      key: "orderWithCastingNo",
      label: "Order / Casting No",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.Order_No}</span>
          <span className="text-[10px] text-slate-400">
            Casting: {row.casting_No}
          </span>
        </div>
      ),
    },
    {
      key: "batchwithDienumber",
      label: "Batch / Die No",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.dieNumber}</span>
          <span className="text-[10px] text-slate-400">
            Die: {row.batch_Id}
          </span>
        </div>
      ),
    },
    {
      key: "orderQtyWithQtyweight",
      label: "Order Qty / Qt Wt",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.qty_Pcs} PCS</span>
          <span className="text-[10px] text-slate-400">
            {row.qty_Weight} WT
          </span>
        </div>
      ),
    },
    {
      key: "orderQtyWithQtyweight",
      label: "Cut Length / Cut Length (mm)",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.cut_Length}</span>
          <span className="text-[10px] text-slate-400">
            {row.cut_Length_MM} (mm)
          </span>
        </div>
      ),
    },
    { key: "profile_Name", label: "Profile" },
    {
      key: "dieInOut",
      label: "Die In / Out",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.die_In}</span>
          <span className="text-[10px] text-slate-400">{row.die_Out}</span>
        </div>
      ),
    },

    {
      key: "inputOutputWt",
      label: "Input / Out Wt",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.input_Weight}</span>
          <span className="text-[10px] text-slate-400">
            {row.output_Weight}
          </span>
        </div>
      ),
    },

    { key: "billet_Size", label: "Billet Size" },
    {
      key: "billetPcs",
      label: "Billet / Pcs",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.no_Of_Billet}</span>
          <span className="text-[10px] text-slate-400">
            {row.no_Of_Pcs} PCS
          </span>
        </div>
      ),
    },
    { key: "pcs_Needed", label: "PCS Needed" },
    { key: "recovry", label: "Recovery %" },
    { key: "billet_Temp", label: "Billet Temp" },
    {
      key: "speedPressure",
      label: "Speed / Pressure",
      render: (_, row) => (
        <div className="flex flex-col text-center">
          <span className="font-medium">{row.ext_Speed}</span>
          <span className="text-[10px] text-slate-400">
            {row.extrusion_Pressure}
          </span>
        </div>
      ),
    },

    { key: "current_Die_Weight", label: "Current Die Wt" },
    { key: "but_End_Rejection_Mm", label: "But End Rej (mm)" },
    {
      key: "created_Date",
      label: "Created Date",
      render: (_, row) => new Date(row.created_Date).toLocaleString(),
    },
    { key: "stertching_Rejection_Ft", label: "Stretch Rej (Ft)" },
    { key: "remark", label: "Remark" },
  ];

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (activeTab !== "finish" && activeTab !== "in-ProductionData") return;

      if (loading || !hasMore || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore, activeTab]);

  const handleFinishRefresh = async () => {
    setIsMarkDoneData([]);
    setHasMore(true);
    setCurrentPage(1);

    const el = tableScrollRef.current?.querySelector(".overflow-y-auto");
    if (el) el.scrollTop = 0;

    await fetchMarkDoneData(1);
    notify("Data loaded (first 50)", "success");
  };

  const closeBilletModal = () => {
    setIsBilletModelOpen(false);

    setBilletModalRow(null);

    setInProductionData((prev) => {
      const updated = [...prev];
      if (billetModalRow) {
        updated[billetModalRow.index].selectedAction = "";
      }
      return updated;
    });
  };

  const handleActionChange = async (index, value) => {
    const updatedData = [...inProductionData];

    updatedData[index].selectedAction = value;
    setInProductionData([...updatedData]);

    if (value === "billet_change") {
      const currentRow = updatedData[index];
      const currentTime = new Date().toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      // Prepare a blank new row for the modal
      const firstBilletSize =
        isCastingData.length > 0 ? isCastingData[0].value : "";

      const newRow = {
        // Keep metadata
        die_Id: currentRow.die_Id,
        order_No: currentRow.order_No,
        batch_Id: currentRow.batch_Id,
        profile_Name: currentRow.profile_Name,
        dieNumber: currentRow.dieNumber,
        qty_Pcs: currentRow.qty_Pcs,
        qty_Weight: currentRow.qty_Weight,
        cut_Length: currentRow.cut_Length,
        order_Detail_Id: currentRow.order_Detail_Id,
        current_Die_Weight: currentRow.current_Die_Weight,
        // Reset production fields
        seq_No: 0,
        casting_No: "",
        die_In: currentTime,
        die_Out: "",
        pcs_Needed: "",
        billet_Size: "",
        no_Of_Billet: "",
        no_Of_Pcs: "",
        output_Weight: 0,
        input_Weight: 0,
        recovry: 0,
        but_End_Rejection_Mm: "",
        stertching_Rejection_Ft: "",
        ext_Speed: "",
        billet_Temp: "",
        remark: "",
        die_Unload_Reason_Id: "",
        selectedAction: "",
        isCloned: true,
      };

      setBilletModalRow({
        old: { ...currentRow },
        new: newRow,
        index,
        currentTime, // Store this to set as die_out of old row when saving
      });

      setIsBilletModelOpen(true);
    }

    if (value === "mark_done") {
      await handleMarkDone(index);
      return;
    }
    if (value === "die_unload") {
      if (!updatedData[index].die_Unload_Reason_Id)
        return notify("Select unload reason first!", "error");

      updatedData[index].selectedAction = "die_unload";
      setInProductionData([...updatedData]);
      return;
    }

    setInProductionData(updatedData);
  };

  const handleProdStart = async (row, index) => {
    try {
      if (!row.casting_No) return notify("Casting No required!", "error");
      if (!row.billet_Size) return notify("Billet Size required!", "error");
      if (!row.no_Of_Billet) return notify("No of billets required!", "error");

      const now = new Date().toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      const updated = [...inProductionData];
      updated[index].die_In = now;
      setInProductionData(updated);

      await handleSave(updated[index], index, { skipRefresh: true });

      const res = await inProduction.ProdStart({
        dieId: updated[index].die_Id,
        orderDetailId: updated[index].order_Detail_Id,
      });

      if (res?.status === true) {
        notify(res?.message || "Success", "success");
      } else {
        notify(res?.message || "Failed", "error");
        return;
      }

      fetchInProductionData();
    } catch (e) {
      console.log(e);
      notify("Prod start failed", "error");
    }
  };

  const handleDieUnload = async (row, index) => {
    if (!row.die_Unload_Reason_Id)
      return notify("Unload reason required!", "error");

    const payload = {
      dieId: row.die_Id,
      orderDetailId: row.order_Detail_Id,
      dieUnloadReasonId: row.die_Unload_Reason_Id,
    };

    try {
      await inProduction.DiaUnload(payload);
      notify("Die Unloaded Successfully!", "success");

      fetchInProductionData();
    } catch (err) {
      console.log(err);
      notify("Die unload failed!", "error");
    }
  };

  return (
    <>
      <div>
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100 mb-6">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-1">
            <div className="space-y-1">
              <h2 className="text-2xl font-bold text-slate-800 tracking-tight flex items-center gap-2">
                Production Management
              </h2>
              <p className="text-sm text-slate-500 font-medium">
                Monitor and manage your daily die production
              </p>
            </div>
            <div className="inline-flex p-1 bg-slate-200/50 rounded-xl backdrop-blur-sm">
              <button
                onClick={() => setActiveTab("in-ProductionData")}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === "in-ProductionData"
                  ? "bg-white text-primary shadow-sm"
                  : "text-slate-600 hover:text-slate-800"
                  }`}
              >
                <LayoutGrid size={16} /> In-Production
              </button>
              <button
                onClick={() => setActiveTab("finish")}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === "finish"
                  ? "bg-white text-primary shadow-sm"
                  : "text-slate-600 hover:text-slate-800"
                  }`}
              >
                <RiHistoryLine size={16} /> Produced Section
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : activeTab === "in-ProductionData" ? (
          <>
            <div
              className={`transition-all duration-500 bg-white rounded-2xl shadow-sm border border-slate-200 ease-in-out overflow-hidden ${isTableExpanded
                ? "max-h-[1000px] opacity-100"
                : "max-h-12 opacity-80"
                }`}
              onMouseEnter={() => setIsTableExpanded(true)}
              onMouseLeave={() => {
                if (inProductionData.length > 0) setIsTableExpanded(false);
              }}
            >
              <div className="flex justify-between items-center bg-gray-50 p-1 cursor-pointer border-b">
                <div className="flex items-center gap-3">
                  <button
                    className="p-2 bg-primary/10 rounded-lg text-primary hover:bg-primary hover:text-gray"
                    onClick={() => fetchDies()}
                  >
                    <TiRefreshOutline size={20} />
                  </button>
                  <div>
                    <h3 className="font-bold text-slate-800">Die Selection</h3>
                    <p className="text-xs text-slate-500">
                      Select dies to start production entry
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <span className="px-3 py-1 bg-primary text-white text-[10px] font-black rounded-full uppercase tracking-tighter">
                    {selectedDies.length} Selected
                  </span>
                  <Button
                    icon={RiRefreshLine}
                    onClick={handleRefresh}
                    className="bg-primary text-white px-2 py-1 rounded"
                  />
                  {isTableExpanded ? (
                    <ChevronUp size={20} />
                  ) : (
                    <ChevronDown size={20} />
                  )}
                </div>
              </div>
              <div className="max-h-72 overflow-y-auto border-t">
                <table className="w-full text-sm text-left border-collapse">
                  <thead className="sticky top-0 bg-white/95 backdrop-blur-md shadow-sm z-10 font-bold text-slate-400 uppercase text-[10px] tracking-widest text-center">
                    <tr>
                      <th className="p-2">✓</th>
                      <th className="p-2">Die No</th>
                      <th className="p-2">Die Status</th>
                      <th className="p-2 ">Current Weight</th>
                      <th className="p-2">Cut Length</th>
                      <th className="p-2">Order Pcs</th>
                      <th className="p-2">Order Pcs Wt</th>
                      <th className="p-2">So No</th>
                      <th className="p-2">Batch ID</th>
                    </tr>
                  </thead>

                  <tbody>
                    {dieList.map((d) => (
                      <tr
                        key={d.die_Id}
                        className="border text-center hover:bg-gray-50"
                      >
                        <td className="p-2 text-center">
                          <input
                            type="checkbox"
                            checked={selectedDies.includes(d.die_Id)}
                            onChange={() => toggleDieSelection(d.die_Id)}
                          />
                        </td>
                        <td className="p-2">{d.dieNumber}</td>
                        <td className="p-2">
                          <span
                            className={`px-2 py-1 rounded-md text-[10px] font-semibold uppercase tracking-wider ${STATUS_COLORS[d.die_Status] || "bg-slate-100 text-slate-600"}`}
                          >
                            {d.die_Status}
                          </span>
                        </td>

                        <td className="p-2">{d.currentWeight}</td>
                        <td className="p-2">{d.cutLength}</td>
                        <td className="p-2">{d.orderPcs}</td>
                        <td className="p-2">{d.orderPcsWeight}</td>
                        <td className="p-2">{d.soNo}</td>
                        <td className="p-2">{d.batchId}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="overflow-x-auto  py-4" ref={tableScrollRef}>
              <div className="space-y-6">
                {inProductionData.length === 0 && !loading && (
                  <div className="p-20 text-center bg-white rounded-[2rem] border-2 border-dashed border-slate-200">
                    <Info className="mx-auto text-slate-300 mb-4" size={40} />
                    <p className="text-slate-400 font-medium">
                      No dies selected. Hover above to select dies and start
                      production.
                    </p>
                  </div>
                )}
                <div className="grid grid-cols-1 gap-6 pb-20">
                  {inProductionData.map((row, i) => (
                    <ProductionCard
                      key={i}
                      row={row}
                      index={i}
                      handleSave={handleSave}
                      handleDieUnload={handleDieUnload}
                      handleActionChange={handleActionChange}
                      handleProdStart={handleProdStart}
                      handleRowChange={handleRowChange}
                      handleSaveBilletChange={handleSaveBilletChange}
                      calcFinal={calcFinal}
                      safeDiv={safeDiv}
                      isCastingData={isCastingData}
                      dieUnloadReason={dieUnloadReason}
                      inProductionData={inProductionData}
                    />
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto pb-12 pt-2">
              <Card className="bg-white h-[calc(100vh_-_280px)]">
                <div
                  ref={tableScrollRef}
                  className="relative overflow-y-auto h-full"
                >
                  <table className="w-full text-center border-collapse">
                    <thead className="sticky top-0 bg-slate-50 border-b border-slate-200 text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                      <tr>
                        {columns.map((col) => (
                          <th
                            key={col.key}
                            className="py-3 px-4 text-center border-b border-slate-200"
                          >
                            {col.label}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 text-[12px]">
                      {isMarkDoneData.map((row, i) => (
                        <tr
                          key={i}
                          className="group transition-all duration-200"
                        >
                          {columns.map((col) => (
                            <td key={col.key} className="py-3 px-4 text-center">
                              {col.render
                                ? col.render(row[col.key], row)
                                : (row[col.key] ?? "")}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
            <div className="sticky bottom-0 left-0 right-0 flex justify-center z-40 pointer-events-none px-6">
              <div className="pointer-events-auto bg-slate-900/95 backdrop-blur-xl text-white py-3 px-6 rounded-2xl shadow-2xl ring-1 ring-white/10 flex items-center gap-8 max-w-2xl w-full justify-between transform transition-all hover:scale-[1.01]">
                <div className="flex items-center gap-8">
                  <div className="flex flex-col">
                    <span className="text-[10px] text-slate-400 uppercase tracking-widest font-bold mb-0.5">
                      Total No. of Pcs
                    </span>
                    <span className="text-xl font-medium text-slate-200 tabular-nums tracking-tight">
                      {pcsTotal}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-right pl-8 border-l border-white/10">
                  <div className="flex flex-col">
                    <span className="text-[10px] text-emerald-400 uppercase tracking-widest font-bold mb-0.5 text-right">
                      Total Output Weight
                    </span>
                    <span className="text-2xl font-bold tracking-tight text-white tabular-nums">
                      {outputWtTotal.toFixed(2)} kg
                    </span>
                  </div>

                  <div
                    className="p-2 bg-white/10 rounded-full text-emerald-400"
                    onClick={handleFinishRefresh}
                  >
                    <RefreshCw size={18} />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {isBilletModelOpen && billetModalRow && (
        <AnimatePresence>
          <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl max-h-[92vh] overflow-hidden flex flex-col"
            >
              <div className="bg-gradient-to-r from-primary to-blue-700 text-white px-6 py-4 flex justify-between items-center border-b border-slate-700">
                <div>
                  <h2 className="text-white text-xl font-bold tracking-tight uppercase">
                    Billet Change
                  </h2>
                  <p className="text-slate-400 text-xs mt-1">
                    Fill in the details to update bundle information.
                  </p>
                </div>
                <button
                  onClick={closeBilletModal}
                  className="hover:bg-white/20 p-2 rounded-full transition-colors"
                >
                  <MdClose size={24} />
                </button>
              </div>
              <ProductionCard
                row={billetModalRow.new}
                index={billetModalRow.index}
                isModal={true}
                handleRowChange={(idx, f, v) => handleModalRowChange(f, v)}
                handleSaveBilletChange={handleSaveBilletChange}
                handleDieUnload={handleDieUnload}
                calcFinal={calcFinal}
                safeDiv={safeDiv}
                isCastingData={isCastingData}
                dieUnloadReason={dieUnloadReason}
              />

            </motion.div>
          </div>
        </AnimatePresence>
      )}
    </>
  );
};

export default InProduction;
